// libs
import styled from "@emotion/styled";

// styles
import { FONTS, DWEB_MAX_WIDTH, BREAKPOINTS } from "shared/styles/base";

export const Container = styled.div<{ alignment: string }>`
    font-family: ${FONTS.CERA};
    width: 100%;
    max-width: ${DWEB_MAX_WIDTH}px;
    font-size: 1.7143rem;
    font-weight: 500;
    text-transform: capitalize;
    padding: 0;
    margin-top: 56px;
    padding-right: 15px;
    text-align: ${props => props.alignment};

    @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
        margin-top: 30px;
    }

    @media (max-width: 768px) {
        font-size: 1.4286rem;
        padding: 5px 5px 0px 5px;
    }
`;
